import React from "react";

import { isEmpty, map } from "lodash";

import NillDisplaySchedule from "../../components/nillDisplaySchedule/NillDisplaySchedule";
import LoadingSkeleton from "../../components/loadingSkeleton/LoadingSkeleton";

import { ICONS } from "../../constants/icons.constants";
import ScheduleListItem from "../../components/scheduleListItem";
import Button from "../../components/button/Button";
import CreateSchedulePopUp from "../../components/createSchedulePopUp";
import ScheduleToPlaySongPopUp from "../../components/scheduleToPlaySongPopUp";
import SchedulesStore from "../../zustand/Schedule.store";

import styles from "./schedule.module.scss";
import userStore from "../../zustand/user.store";

const Schedule = () => {
  const { schedules } = SchedulesStore((state) => ({
    schedules: state.schedules,
  }));
  const { userOffline } = userStore((state) => ({
    userOffline: state.userOffline,
  }));

  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [isVisible, setIsVisible] = React.useState(false);
  const [selectedPlaylist, setSelectedPlaylist] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);

  // const schedules = compact(map(playList, (item) => item.schedule));

  const onBtnClick = () => {
    setIsModalVisible(true);
  };
  const handleSuccess = (selectedPlaylist) => {
    setSelectedPlaylist(selectedPlaylist);
    setIsModalVisible(false);

    setIsVisible(true);
  };

  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <p>My Schedules</p>
        <Button
          onClick={onBtnClick}
          className={styles.btn}
          disabled={userOffline}
        >
          Create Schedule
        </Button>
      </div>

      <div className={styles.container}>
        {isLoading ? (
          <>
            <LoadingSkeleton isSchedule />
            <LoadingSkeleton isSchedule />
            <LoadingSkeleton isSchedule />
            <LoadingSkeleton isSchedule />
            <LoadingSkeleton isSchedule />
          </>
        ) : isEmpty(schedules) ? (
          <NillDisplaySchedule
            head="You do not have any schedules you can create one for you here from playlist page"
            btnPlaceholder="Create Schedule"
            iconType={ICONS.MY_SCHEDULE}
            onBtnClick={onBtnClick}
          />
        ) : (
          map(schedules, (schedule, index) => {
            return map(schedule.slots, (item1, index1) => (
              <ScheduleListItem
                playlistId={schedule?.playlist_id}
                scheduleListView
                scheduleName={schedule?.name}
                totalHours={item1?.start_time}
                days={item1?.days}
                key={item1.slots?.id}
                slotId={item1?.id}
                scheduleId={schedule?.id}
                slots={schedule?.slots}
                // schduleIndex={sIndex}
                schedules={schedule.slots}
                imageUrl={schedule?.thumbnail_img}
                color={schedule.color}
              />
            ));

            // return <div key={item1?.id} />;
          })
        )}
      </div>
      <CreateSchedulePopUp
        isOpen={isModalVisible}
        setIsOpen={setIsModalVisible}
        iconType={ICONS.RED_DELETE}
        btnPlaceholder="Continue"
        onCancle={() => setIsModalVisible(false)}
        isLoading={isLoading}
        handleSuccess={handleSuccess}
      />
      {isVisible && selectedPlaylist ? (
        <ScheduleToPlaySongPopUp
          playlistId={selectedPlaylist}
          setIsVisible={setIsVisible}
          from="schedule"
        />
      ) : null}
    </div>
  );
};

export default Schedule;
